import { store } from "../store";

export const updateThemeMode = (themeMode) => {
  return store.dispatch({ type: "themeMode/update", payload: themeMode });
};
